const $personTypeInput = $('[name="person_type"]');

const $nameInput = $('[name="name"]');
const $nameLabel = $nameInput.parents('.form-group').find('label');

const $documentInput = $('[name="document"]');
const $documentLabel = $documentInput.parents('.form-group').find('label');

const $zipCodeInput = $('[name="zipcode"]:not([type="hidden"])');
const $countryInput = $('[name="country"]');
const $selectStateInput = $('[name="select_state"]');

onload = (event) => {
    if(userAddress.country == 'BRA') {

        if(user.person_type == 1) {
            // Brasil Pessoa Física
            $documentInput.mask('000.000.000-00');
        } else {
            // Brasil Pessoa Jurídica
            $documentInput.mask('00.000.000/0000-00');
        }

        // Endereço Brasil
        $zipCodeInput.mask('00000-000');

    } else {

        if(user.person_type == 1) {
            // Outros Países Pessoa Física
            $documentInput.unmask();
        } else {
            // Outros Países Pessoa Física
            $documentInput.unmask();
        }

        // Endereço Outros Países
        $zipCodeInput.unmask();
    }
}

$personTypeInput.on('change', function() {
    const $this = $(this);

    $nameInput.val('');
    $documentInput.val('');

    if(userAddress.country == 'BRA') {
        if($this.val() == 1) {
            $nameLabel.html(nameInputData['1'][lang]['label']);
            $nameInput.attr('placeholder', nameInputData['1'][lang]['placeholder']);

            $documentLabel.html(documentInputData['1'][lang]['label']);
            $documentInput.attr('placeholder', documentInputData['1'][lang]['placeholder']);
            $documentInput.mask('000.000.000-00');

        } else {
            $nameLabel.html(nameInputData['2'][lang]['label']);
            $nameInput.attr('placeholder', nameInputData['2'][lang]['placeholder']);

            $documentLabel.html(documentInputData['2'][lang]['label']);
            $documentInput.attr('placeholder', documentInputData['2'][lang]['placeholder']);
            $documentInput.mask('00.000.000/0000-00');
        }
    } else {
        $nameLabel.html(nameInputData[$this.val()][lang]['label']);
        $nameInput.attr('placeholder', nameInputData[$this.val()][lang]['placeholder']);

        $documentLabel.html(documentInputData[$this.val()][lang]['label']);
        $documentInput.attr('placeholder', '');
        $documentInput.unmask();
    }
});

if ($('.is-invalid').length) {
    $(window).scrollTop($('.is-invalid:eq(0)').parents('.row').offset().top - 60);
}

$zipCodeInput.blur(function() {

    if($countryInput.val() == 'BRA') {

        var cep = $(this).val().replace(/\D/g, '');
        if (cep != '') {
            var validacep = /^[0-9]{8}$/;
            if (validacep.test(cep)) {
                $.getJSON('https://viacep.com.br/ws/'+ cep +'/json/?callback=?', function(dados) {

                    if(!('erro' in dados)) {

                        if(dados.logradouro != '') {
                            $('[name="address"]').val(dados.logradouro).attr('readonly', true);
                        } else {
                            $('[name="address"]').attr('readonly', false);
                        }

                        if(dados.bairro != '') {
                            $('[name="neighborhood"]').val(dados.bairro).attr('readonly', true);
                        } else {
                            $('[name="neighborhood"]').attr('readonly', false);
                        }

                        $('[name="city"]').val(dados.localidade).attr('readonly', true);
                        $('[name="state"]').val(dados.uf);
                        $('[name="select_state"]').val(dados.uf).attr('disabled', true);
                        // $('[name="number"]').focus();

                        $('[name="zipcode"]').parents('.form-group').find('.invalid-feedback').remove();
                        $('[name="zipcode"]').removeClass('is-invalid');

                        $('[name="address"]').parents('.form-group').find('.invalid-feedback').remove();
                        $('[name="address"]').removeClass('is-invalid');

                        $('[name="neighborhood"]').parents('.form-group').find('.invalid-feedback').remove();
                        $('[name="neighborhood"]').removeClass('is-invalid');

                        $('[name="city"]').parents('.form-group').find('.invalid-feedback').remove();
                        $('[name="city"]').removeClass('is-invalid');

                        $('[name="select_state"]').parents('.form-group').find('.invalid-feedback').remove();
                        $('[name="select_state"]').removeClass('is-invalid');


                    } else {
                        $('[name="address"]').val('').attr('readonly', false);
                        $('[name="neighborhood"]').val('').attr('readonly', false);
                        $('[name="city"]').val('').attr('readonly', false);
                        $('[name="state"]').val('');
                        $('[name="select_state"]').val(dados.uf).attr('disabled', false);
                    }
                }).fail(function() {
                    $('[name="address"]').val('').attr('readonly', false);
                    $('[name="neighborhood"]').val('').attr('readonly', false);
                    $('[name="city"]').val('').attr('readonly', false);
                    $('[name="state"]').val('');
                    $('[name="select_state"]').val(dados.uf).attr('disabled', false);
                });
            }
        }
    }
}).trigger('blur');

$selectStateInput.on('change', function() {
    var $this = $(this);
    $('[name="state"]').val($this.val());
});

$countryInput.on('change', function() {

    if($(this).val() == 'BRA') {
        $('[name="address"]').val('').attr('readonly', true);
        $('[name="neighborhood"]').val('').attr('readonly', true);
        $('[name="city"]').val('').attr('readonly', true);
        $('[name="state"]').val('');
        $('[name="select_state"]').val('').attr('disabled', true).show();
        $('[name="state"]').attr('type', 'hidden').hide();
        $('[name="zipcode"]').mask('00000-000');
    } else {
        $('[name="address"]').val('').attr('readonly', false);
        $('[name="neighborhood"]').val('').attr('readonly', false);
        $('[name="city"]').val('').attr('readonly', false);
        $('[name="state"]').val('');
        $('[name="select_state"]').val('').attr('disabled', false).hide();
        $('[name="state"]').attr('type', 'text').show();
        $('[name="zipcode"]').unmask();
        $('[name="document"]').unmask();
    }
});

$('.btn-edit-contract').on('click', function() {
    const $btn = $(this);
    const $form = $btn.parents('form');
    $form.find('input[name="action"]').val('edit-contract');
});